/**
 * Merges objects with common keys from two arrays.
 * If a key exists in both arrays, the values are merged deeply.
 * @param arr1 - First array of objects
 * @param arr2 - Second array of objects
 * @returns Merged array with combined objects for common keys
 */
export const mergeCommonKeys = (arr1: { [k: string]: any }[], arr2: { [k: string]: any }[]) => {
  const merged: { [k: string]: any } = {};

  // Add all items from arr1
  arr1.forEach((item) => {
    const [key, value] = Object.entries(item)[0];
    merged[key] = value;
  });

  // Merge or add items from arr2
  arr2.forEach((item) => {
    const [key, value] = Object.entries(item)[0];
    if (merged[key]) {
      // If key exists, merge the values
      if (typeof merged[key] === 'object' && !Array.isArray(merged[key]) && merged[key] !== null) {
        merged[key] = { ...merged[key], ...value };
      } else if (Array.isArray(merged[key]) && Array.isArray(value)) {
        merged[key] = [...merged[key], ...value];
      } else {
        // For primitive values, arr2 takes precedence
        merged[key] = value;
      }
    } else {
      merged[key] = value;
    }
  });

  // Convert back to array format
  return Object.entries(merged).map(([key, value]) => ({ [key]: value }));
};
